import { handleActions } from 'redux-actions'
import {
  leaderUsersByCenterIdsStart,
  leaderUsersByCenterIdsSuccess,
  leaderUsersByCenterIdsError,
} from 'actions/leaderUsersByCenterIds'

const defaultState = {
  success: false,
  values: [],
  cache: [],
  error: null,
  isFetching: false,
}

const reducer = handleActions(
  {
    [leaderUsersByCenterIdsStart]: (state) => ({
      ...state,
      success: false,
      isFetching: true,
      error: [],
    }),
    [leaderUsersByCenterIdsSuccess]: (state, { payload: { values } }) => ({
      ...state,
      success: true,
      values,
      cache: [
        ...state.cache,
        ...values.filter((newValue) => !state.cache.find((x) => x.centerId === newValue.centerId)),
      ],
      isFetching: false,
    }),
    [leaderUsersByCenterIdsError]: (state, { payload: { error } }) => ({
      ...state,
      success: false,
      isFetching: true,
      error,
    }),
  },
  defaultState
)

export default reducer
